module.exports = __webpack_public_path__ + "img/dark-mode-icon-active.a32cf643.svg";